import * as yup from 'yup';
import { isRequiredLinkDevice } from './isRequiredLinkDevice';

const nullableStringField = yup
  .string()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue === null || originalValue === undefined) {
      return null;
    }

    return value;
  });

export const regModlinkSchema = yup.object({
  mac: yup
    .string()
    .required('MAC을 입력하세요.')
    .test('mac-length', 'MAC은 12자리여야 합니다.', (value) => {
      if (!value) return true;

      return value.length === 12;
    })
    .test('mac-format', 'MAC은 영문 대문자와 숫자만 입력 가능합니다.', (value) => {
      if (!value) return true;

      return /^[0-9A-F]{12}$/.test(value);
    }),
  deviceType: nullableStringField.required('디바이스 종류를 선택하세요.'),
  serialNum: yup.string().required('시리얼 넘버를 입력하세요.'),
  link1: nullableStringField.when('deviceType', {
    is: (deviceType: string | null) => isRequiredLinkDevice(deviceType || undefined),
    then: (schema) => schema.required('링크1 종류를 선택하세요.'),
    otherwise: (schema) => schema,
  }),
  link2: nullableStringField.when('deviceType', {
    is: (deviceType: string | null) => isRequiredLinkDevice(deviceType || undefined),
    then: (schema) => schema.required('링크2 종류를 선택하세요.'),
    otherwise: (schema) => schema,
  }),
  planId: nullableStringField,
  networkType: nullableStringField.required('네트워크 종류를 선택하세요.'),
  salesManager: nullableStringField,
  memo: nullableStringField,
  modemId: nullableStringField,
  distributorCompany: nullableStringField.required('납품처를 선택하세요.'),
});
